var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar",class:{
    visible: !_vm.hasAnimation,
    animation: _vm.hasAnimation,
    'animation--left': _vm.hasAnimation && _vm.isLeft,
    'animation--right': _vm.hasAnimation && !_vm.isLeft,
  }},[_c('div',{staticClass:"avatar__image",style:(_vm.style)}),(_vm.title)?_c('div',{staticClass:"avatar__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }